import React from 'react';
import { useSectionNewsBlockQuery } from '../hooks/useNewsListQuery';
import HorizontalNewsCarousel from './HorizontalNewsCarousel';

const sectionLinks = {
  'Чемпіонат світу 2026': '/tournaments/world-cup-2026',
  'Чемпіонат Європи з футзалу 2026': '/tournaments/futsal-euro-2026',
  'Клубний чемпіонат світу 2025': '/tournaments/club-world-cup-2025',
};

const HorizontalSectionNewsSlider = ({
  title,
  section,
  limit = 20,
}) => {
  const {
    news: sectionNews,
    initialLoading,
  } = useSectionNewsBlockQuery(section, limit);

  const titleLink = sectionLinks[section] || null;

  return (
    <HorizontalNewsCarousel
      title={title}
      titleLink={titleLink}
      news={sectionNews}
      initialLoading={initialLoading}
    />
  );
};

export default HorizontalSectionNewsSlider;
